var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message__block"},[_c('hcc-audio',{attrs:{"src":_vm.fullUrl,"ext":_vm.extension}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }